import * as THREE from 'three'

/** カメラ下部に追従する字幕板（CanvasTexture）。多言語語り部(A6)の字幕スタブ。 */
export class Subtitle {
  private canvas = document.createElement('canvas')
  private ctx: CanvasRenderingContext2D
  private texture: THREE.CanvasTexture
  private mesh: THREE.Mesh
  private hideAt = 0
  private clock = 0

  constructor(camera: THREE.Camera) {
    this.canvas.width = 1024
    this.canvas.height = 288
    this.ctx = this.canvas.getContext('2d')!
    this.texture = new THREE.CanvasTexture(this.canvas)
    this.texture.colorSpace = THREE.SRGBColorSpace
    const mat = new THREE.MeshBasicMaterial({
      map: this.texture,
      transparent: true,
      depthTest: false,
      depthWrite: false,
    })
    this.mesh = new THREE.Mesh(new THREE.PlaneGeometry(1.15, 0.32), mat)
    this.mesh.position.set(0, -0.42, -1.3)
    this.mesh.renderOrder = 9000
    this.mesh.visible = false
    camera.add(this.mesh)
  }

  show(text: string, seconds = 8): void {
    const ctx = this.ctx
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    const lines = this.wrap(text, 24).slice(0, 4)
    const lineH = 58
    const boxH = lines.length * lineH + 40
    const boxY = this.canvas.height - boxH
    ctx.fillStyle = 'rgba(10, 10, 14, 0.62)'
    ctx.beginPath()
    ctx.roundRect(24, boxY, this.canvas.width - 48, boxH, 16)
    ctx.fill()
    ctx.font = '600 42px "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    lines.forEach((line, i) => {
      const y = boxY + 40 + i * lineH
      ctx.strokeStyle = 'rgba(0,0,0,0.9)'
      ctx.lineWidth = 6
      ctx.strokeText(line, this.canvas.width / 2, y)
      ctx.fillStyle = '#f4eedb'
      ctx.fillText(line, this.canvas.width / 2, y)
    })
    this.texture.needsUpdate = true
    this.mesh.visible = true
    this.hideAt = this.clock + seconds
  }

  clear(): void {
    this.mesh.visible = false
  }

  update(dt: number): void {
    this.clock += dt
    if (this.mesh.visible && this.clock >= this.hideAt) this.mesh.visible = false
  }

  /** 日本語向けの単純な文字数折り返し */
  private wrap(text: string, maxChars: number): string[] {
    const lines: string[] = []
    let line = ''
    for (const ch of text) {
      if (ch === '\n') {
        lines.push(line)
        line = ''
        continue
      }
      line += ch
      if (line.length >= maxChars) {
        lines.push(line)
        line = ''
      }
    }
    if (line.length > 0) lines.push(line)
    return lines
  }
}
